import * as apiPostSearch from 'api/baseIngredient/PostBaseIngredientSearchV1';
import * as BaseIngredient from 'types/BaseIngredient/Search/BaseIngredient';

export type Type = BaseIngredient.Type[];

export function create(): Type {
	return [];
}

export function mapFromApi(obj: apiPostSearch.ResponseBaseIngredient[]): Type {
	return [...obj];
}
